import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from '../../../../core/services/notification.service';
import { UsrBtnComponent } from '../../../../Shared/Components/usr-btn/usr-btn.component';
import { UsrCardComponent } from '../../../../Shared/Components/usr-card/usr-card.component';
import { Usermodel } from '../../Models/UserModel.interface';
import { NSLoginService } from '../../Services/NSLogin.service';
import { TenantsService } from '../../../../core/services/tenants.service';
import { StorageService } from '../../../../core/services/storage-service.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'NS-user-login',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterLink,
    UsrBtnComponent,
    UsrCardComponent,
  ],
  templateUrl: './NS-user-login.component.html',
  styleUrl: './NS-user-login.component.scss',
})
export class NSUserLoginComponent {
  User: Usermodel = {
    Username: '',
    Password: '',
    CompanyId: this.tenantService.getTenantFromSubdomain(),
  };
  showPassword: boolean = false;
  guestuser: boolean = true;
  isloading: boolean = false;
  showForgotPassword: boolean = false;
  isupdatepassword: boolean = false;
  forgotEmail: string = '';
  updatePasswordForm!: FormGroup;
  passkey: string = '';
  constructor(
    private loginservice: NSLoginService,
    private notify: NotificationService,
    private tenantService: TenantsService,
    private router: Router,
    private storageService: StorageService,
    private http: HttpClient,
    private fb: FormBuilder,
    private actroute: ActivatedRoute
  ) {
    this.initUpdatePasswordForm();
  }

  toggleForgotPassword() {
    this.showForgotPassword = !this.showForgotPassword;
  }

  onForgotSubmit(forgotfrm: any) {
    let payload = {
      "email": forgotfrm.forgotEmail,
      "companyId": this.tenantService.getTenantFromSubdomain()
    }
    this.http.post(environment.BACKOFFICE_URL + "/login/forgetpasswordBO", payload).subscribe({
      next: (res: any) => {
        if (res.status == 1) {
          this.http.get(environment.B2CAPI_URL + "/api/EmailService/forgetpasswordBO?passwordkey=" + res.passwordkey).subscribe({
            next: (resp: any) => {
              this.notify.success('If an account exists for ' + forgotfrm.forgotEmail + ', a temprary link has been sent.');
              this.showForgotPassword = false;
            },
            error: (err) => {
              this.notify.error('Failed to send temprary link');
            }
          })
        } else {
          this.notify.error('Failed to send temprary link');
        }
      },
      error: (err) => {
        this.notify.error('Failed to send temprary link');
      }
    })
  }
  ngOnInit(): void {
    this.actroute.queryParamMap.subscribe(params => {
      this.passkey = params.get('passkey') || '';
      if (this.passkey) {
        this.isupdatepassword = true;
        this.showForgotPassword = false;
      }
    });
    const token = this.loginservice.gettoken();
    if (token) {
      if (this.loginservice.LoginwithToken(token)) {
        this.guestuser = false;
        this.router.navigate(['userhome']);
      }
    }
  }
  onSubmit(loginfrm: any) {
    this.isloading = true;
    setTimeout(() => {
      this.loginservice.Userlogin(loginfrm).subscribe({
        next: (res: any) => {

          if (this.loginservice.LoginwithToken(res.tokenvalue)) {
            this.guestuser = false;
            this.storageService.setLocal('username', res?.name || "");
            this.router.navigate(['/userhome']);
          }
          else {
            this.notify.error('Failed to login');
          }
        },
        error: (err) => {
          this.notify.error('Failed to login');
          this.isloading = false;
        },
        complete: () => {
          this.isloading = false;
        },
      });
    }, 300);
  }

  initUpdatePasswordForm() {
    this.updatePasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmpassword: ['', [Validators.required]],
      passkey: [this.passkey]
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const confirmpassword = control.get('confirmpassword');

    if (!password || !confirmpassword) return null;

    return password.value === confirmpassword.value ? null : { passwordMismatch: true };
  }

  onUpdatePasswordSubmit() {
    if (this.updatePasswordForm.valid) {
      console.log('Update Password form submitted:', this.updatePasswordForm.value);
      this.updatePasswordForm.value.passkey = this.passkey;
      this.http.post(environment.BACKOFFICE_URL + "/login/ResetpasswordBO", this.updatePasswordForm.value).subscribe({
        next: (res: any) => {
          if (res.status == 1) {
            this.notify.success('Password updated successfully');
            this.isupdatepassword = false;
            this.router.navigate(['/userlogin']);
          } else {
            this.notify.error('Failed to update password');
          }
        },
        error: (err) => {
          this.notify.error('Failed to update password');
        }
      })
    }
  }
}
